import { createSimulation, updateSimulation } from '@client/services/simulate'
import cleanUpNumbers from '@client/utils/sanitizer'

const LOAD = 'simulate/LOAD'
const LOAD_FROM_MAGIC_LINK = 'simulate/LOAD_FROM_MAGIC_LINK'
const ADD_OFFER = 'simulate/ADD_COUPON'
const ADD_RECAPTCHA = 'simulate/ADD_RECAPTCHA'
const LOAD_BROKER_CONTACT = 'simulate/LOAD_BROKER_CONTACT'

export default function reducer(state = {}, action = {}) {
  switch (action.type) {
    case LOAD:
      return {
        ...state,
        ...action.simulate,
      }

    case ADD_RECAPTCHA:
      return {
        ...state,
        ...action.captcha,
      }

    case ADD_OFFER:
      return {
        ...state,
        commercialOffer: {
          ...state.commercialOffer,
          ...action.offer,
        },
      }

    default:
      return state
  }
}

export function loadSimulate(simulate) {
  return { type: LOAD, simulate }
}

export function addReCaptcha(captcha) {
  return { type: ADD_RECAPTCHA, captcha }
}

export function addOffer(offer) {
  return { type: ADD_OFFER, offer }
}

export function loadFromMagicLink(magicLink) {
  return { type: LOAD_FROM_MAGIC_LINK, magicLink }
}

export function createContact(newContact) {
  const contact = {
    ...newContact,
  }

  if (newContact.mobilePhone) {
    contact.mobilePhone = cleanUpNumbers(newContact.mobilePhone)
  }

  return async dispatch => {
    const response = await createSimulation(contact)
    await dispatch(loadSimulate({ ...contact, ...response }))
  }
}

export function updateContact(upContact) {
  const { emailCheck, ...restContact } = upContact
  const contact = restContact

  if (contact.mobilePhone) {
    contact.mobilePhone = cleanUpNumbers(contact.mobilePhone)
  }

  return async dispatch => {
    await dispatch(loadSimulate(contact))
    await updateSimulation(contact)
  }
}

export function loadBrokerContact(contact) {
  return { type: LOAD_BROKER_CONTACT, contact }
}

const types = {
  LOAD,
  ADD_OFFER,
  ADD_RECAPTCHA,
  LOAD_FROM_MAGIC_LINK,
  LOAD_BROKER_CONTACT,
}

const actions = {
  loadSimulate,
  addReCaptcha,
  addOffer,
}

export { types, actions }
